/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scan_Url_Not_ProductInputs */

const vi_scan_url_not_product = /** @type {(inputs: Scan_Url_Not_ProductInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mã vừa quét là đường dẫn (QR phiếu/liên kết), không phải mã sản phẩm.`)
};

/**

* @param {Scan_Url_Not_ProductInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const scan_url_not_product = /** @type {((inputs?: Scan_Url_Not_ProductInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scan_Url_Not_ProductInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_scan_url_not_product(inputs)
});